import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class ScriptService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  public loadJsScript(src: string): HTMLScriptElement {
    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    this.document.body.appendChild(script);
    return script;
  }

  public loadExternalCss(src: string): HTMLStyleElement {
    const link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = src;
    this.document.body.appendChild(link);
    return link;
  }
}
